import { clone } from "lodash";

const values = {
  email: "",
};

const saveQuoteInitialFormValues = () => clone(values);

export default saveQuoteInitialFormValues;
